(() => {
  const initialize = () => {
    const overlay = document.querySelector('[data-dt-halloween-idle]');
    const zombie = document.querySelector('[data-dt-halloween-zombie]');
    const controllerRoot = overlay || zombie;
    if (!controllerRoot || window.Shopify?.designMode || controllerRoot.dataset.dtHalloweenInitialized) return;
    controllerRoot.dataset.dtHalloweenInitialized = 'true';

    const bloodDelay = 5 * 60 * 1000;
    const zombieDelay = 60 * 1000;
    const zombieDuration = 20 * 1000;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const forcedColors = window.matchMedia('(forced-colors: active)');
    let timer = null;
    let zombieCleanupTimer = null;
    let lastActivity = Date.now();
    let paused = false;
    let zombieShown = false;
    let bloodShown = false;

    const clearTimer = () => {
      if (timer !== null) window.clearTimeout(timer);
      timer = null;
    };

    const hideEffect = (element) => {
      if (!element) return;
      if (element === zombie && zombieCleanupTimer !== null) {
        window.clearTimeout(zombieCleanupTimer);
        zombieCleanupTimer = null;
      }
      element.hidden = true;
      element.classList.remove('is-active');
    };

    const hide = () => {
      hideEffect(overlay);
      hideEffect(zombie);
    };

    const permitted = () => !paused && !document.hidden && !reducedMotion.matches && !forcedColors.matches;

    const schedule = () => {
      clearTimer();
      if (!permitted()) return;
      let nextDelay = Infinity;
      if (zombie && !zombieShown) nextDelay = zombieDelay;
      if (overlay && !bloodShown) nextDelay = Math.min(nextDelay, bloodDelay);
      if (!Number.isFinite(nextDelay)) return;
      const remaining = Math.max(0, nextDelay - (Date.now() - lastActivity));
      timer = window.setTimeout(() => {
        timer = null;
        if (!permitted()) return;
        const elapsed = Date.now() - lastActivity;
        if (zombie && !zombieShown && elapsed >= zombieDelay) {
          zombieShown = true;
          zombie.hidden = false;
          zombie.classList.add('is-active');
          zombieCleanupTimer = window.setTimeout(() => {
            zombieCleanupTimer = null;
            hideEffect(zombie);
          }, zombieDuration);
        }
        if (overlay && !bloodShown && elapsed >= bloodDelay) {
          bloodShown = true;
          overlay.hidden = false;
          overlay.classList.add('is-active');
        }
        schedule();
      }, remaining);
    };

    const resetClock = () => {
      lastActivity = Date.now();
      zombieShown = false;
      bloodShown = false;
      schedule();
    };

    const reset = () => {
      hide();
      resetClock();
    };

    const suspend = () => {
      paused = true;
      clearTimer();
      hide();
    };

    const resume = () => {
      paused = false;
      reset();
    };

    const onActivity = (event) => {
      if (event.isTrusted === false) return;
      hideEffect(overlay);
      resetClock();
    };

    ['pointermove', 'mousemove', 'pointerdown', 'touchstart', 'touchmove', 'keydown', 'wheel', 'input'].forEach((event) => {
      document.addEventListener(event, onActivity, { passive: true, capture: true });
    });
    document.addEventListener('visibilitychange', reset);
    window.addEventListener('blur', suspend);
    window.addEventListener('focus', resume);
    window.addEventListener('pagehide', suspend);
    window.addEventListener('pageshow', resume);
    reducedMotion.addEventListener('change', reset);
    forcedColors.addEventListener('change', reset);
    if (zombie) {
      const walker = zombie.querySelector('.dt-halloween-zombie__walker');
      zombie.addEventListener('animationend', (event) => {
        if (event.target === zombie || event.target === walker) hideEffect(zombie);
      });
    }
    reset();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
